import { Box } from "@mui/material";

import { MinRateCapacityReason } from "@/features/FormV2/Step1/TicketingSelectionV2Card/helpers/calculateMaximumPurchasableTicketsForRate";
import { useRateSoldOutReasonMessage } from "@/features/FormV2/Step1/TicketingSelectionV2Card/hooks/useRateSoldOutReasonMessage";
import { FormButton } from "@/forms-design-system/FormButton";
import { FormTooltip } from "@/forms-design-system/FormTooltip";
import { useTranslate } from "@/hooks/useTranslate";

export type ThemedSoldOutButtonProps = {
  itemType: "ticket" | "item" | "membership";
  maximumToBuy: number;
  maximumReason: MinRateCapacityReason;
  isP2PLinkedEvent?: boolean;
};

export const ThemedSoldOutButton = ({
  itemType,
  maximumToBuy,
  maximumReason,
  isP2PLinkedEvent,
}: ThemedSoldOutButtonProps) => {
  const { t } = useTranslate();

  const maximumReachedTooltipMessage = useRateSoldOutReasonMessage({ itemType, maximumToBuy, maximumReason });

  return (
    <FormTooltip title={maximumReachedTooltipMessage}>
      {/* We need to put a box here so that the tooltip appears correctly */}
      <Box width="fit-content">
        <FormButton
          variant="tonal"
          sx={{
            minWidth: { xs: 0, md: 140 },
            pointerEvents: "none",
            opacity: 1, // Override the default disabled opacity as the parent component already reduces opacity when disabled
          }}
          disabled
          data-test="themed-sold-out-button"
        >
          {t("ticketing", itemType === "membership" || isP2PLinkedEvent ? "select" : "soldOut")}
        </FormButton>
      </Box>
    </FormTooltip>
  );
};
